var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6875 9.75H17.0625V13.125H13.6875V21H10.3125V13.125H6.9375V9.75H10.3125V8.33813C10.3125 7.0005 10.7332 5.31075 11.5703 4.38713C12.4072 3.46163 13.452 2.99925 14.7045 3H17.0625V6.375H14.7C14.1397 6.375 13.6875 6.82725 13.6875 7.38638V9.75Z",
    fill: "#23242F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBook);
export default __webpack_public_path__ + "static/media/face-book.25c255ac2e7d64280ec67692bb987ee6.svg";
export { ForwardRef as ReactComponent };